type Point = { x: number; y: number }

// One closed ribbon rather than separately blended line segments: no bright joints
// or square cap at the weapon tip. The centreline is supplied by the existing arc.
export function sweepRibbonEdges(points: Point[], inner: Point[], width: number): Point[] {
  if (points.length < 2 || points.length !== inner.length || width <= 0) return []
  const outerEdge: Point[] = []
  const innerEdge: Point[] = []
  const last = points.length - 1
  for (let i = 0; i <= last; i++) {
    const p = points[i]!
    const radial = { x: p.x - inner[i]!.x, y: p.y - inner[i]!.y }
    const length = Math.hypot(radial.x, radial.y) || 1
    const u = i / last
    // Both ends meet the centreline exactly; weight is carried toward the tip.
    const taper = i === 0 || i === last ? 0 : Math.pow(Math.sin(Math.PI * u), 0.65) * (0.35 + 0.65 * u)
    const half = width * taper / 2
    const dx = radial.x / length * half
    const dy = radial.y / length * half
    outerEdge.push({ x: p.x + dx, y: p.y + dy })
    innerEdge.push({ x: p.x - dx, y: p.y - dy })
  }
  return [...outerEdge, ...innerEdge.reverse()]
}

export function drawSweepRibbon(
  ctx: CanvasRenderingContext2D, points: Point[], inner: Point[],
  width: number, alpha: number, color: string,
): void {
  if (alpha <= 0 || points.length < 2) return
  const polygon = sweepRibbonEdges(points, inner, width)
  if (!polygon.length) return
  ctx.save()
  ctx.globalCompositeOperation = 'source-over'
  ctx.globalAlpha *= alpha
  ctx.shadowBlur = 0
  ctx.fillStyle = color
  ctx.beginPath()
  ctx.moveTo(polygon[0]!.x, polygon[0]!.y)
  for (const point of polygon.slice(1)) ctx.lineTo(point.x, point.y)
  ctx.closePath()
  ctx.fill()
  ctx.restore()
}
